// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3V3ge","icon":"SortAdornment_icon__3MwA2","up":"SortAdornment_up__2eN1v","down":"SortAdornment_down__3oedd","active":"SortAdornment_active__260ak"};